import useTranslation from "utils/hooks/useTranslation";
import useCustomForm from "utils/hooks/useCustomForm";
import { Popup } from "components/popups/Popup";
// import { env } from "env";
import Input, { InputType } from "components/shared/inputs/input";
import { Link } from "react-router";
import Button from "components/shared/button";
// import Checkbox from "components/shared/inputs/checkbox";
import { useGetPdfURLMutation } from "store/api";
import { useEffect, useRef, useState } from "react";
import Loader from "components/shared/loader";

export const MailPopup: React.FC<{
  etudeIds: string;
  networkId?: number;
  showPrice?: boolean;
  isEtudeDetail?: boolean;
  culture?: string;
  // etudeURL?: string | string[];
}> = ({
  etudeIds,
  networkId,
  showPrice,
  isEtudeDetail,
  culture,
  // etudeURL
}) => {
  const pdfURL = useRef<string>("");
  const { t } = useTranslation();

  const { control, watch } = useCustomForm<any>({
    defaultValues: {
      recipient: "",
      subject: t("FO_MAIL_TITLE_THERMODIM"),
      message: t("FO_MAIL_BODY"),
      // mailStudy: false,
      // mailPdf: false
    },
  });

  // const mailStudy = watch("mailStudy");
  // const mailPdf = watch("mailPdf");

  const [getEtudePDF] = useGetPdfURLMutation();
  const [isPdfURLLoading, setIsPdfURLLoading] = useState<boolean>(false);
  useEffect(() => {
    (async () => {
      try {
        setIsPdfURLLoading(true);
        pdfURL.current = await getEtudePDF({
          etudeIds,
          networkId,
          showPrice,
          isEtudeDetail,
          culture,
        }).unwrap();
        setIsPdfURLLoading(false);
      } catch (error) {
        setIsPdfURLLoading(false);
        message.error("Error getting PDF: Something went wrong");
        console.error("Error getting PDF:", error);
      }
    })();
  }, []);

  const recipient = watch("recipient");
  const subject = watch("subject");
  const message = watch("message");
  // const studyUrlLine = mailStudy ? `${t("FO_MAIl_BODY_STUDY")}: ${env.app_url}${Array.isArray(etudeURL) ? etudeURL.join(", ") : etudeURL}` : "";
  const dynamicMessage = `${message}: ${
    Array.isArray(pdfURL.current) ? pdfURL.current.join(",\n") : pdfURL.current
  }`;
  const mailto = recipient
    ? `mailto:${recipient}?subject=${subject}&body=${encodeURIComponent(
        dynamicMessage
      )}`
    : "#";

  return (
    <Popup title={t("FO_DOC_SHARE")}>
      {isPdfURLLoading && <Loader />}
      <group
        data-direction="column"
        data-gap="20"
        data-space="20"
        data-length="600"
      >
        <form data-type="group">
          <group data-direction="column" data-gap="10" data-length="autofit">
            <Input
              label={t("FO_MAIL_RECIPIENT")}
              placeholder={t("")}
              name="recipient"
              control={control}
              type={InputType.Text}
            />
            <Input
              label={t("FO_MAIL_OBJECT")}
              name="subject"
              control={control}
              type={InputType.Text}
            />
            <Input name="message" control={control} type={InputType.TextArea} />
            {/* <group data-gap="10">
                            <Checkbox
                                label={t("FO_MAIl_BODY_STUDY")}
                                control={control}
                                name="mailStudy"
                            />
                            <Checkbox
                                label={t("FO_MAIL_BODY_PDF")}
                                control={control}
                                name="mailPdf"
                            />
                        </group> */}
          </group>
        </form>
        <group data-justify="end">
          <Link to={mailto}>
            <Button primary large {...(!recipient ? { disabled: true } : {})}>
              {t("FO_MAIL_SEND")}
            </Button>
          </Link>
        </group>
      </group>
    </Popup>
  );
};
